import { render, staticRenderFns } from "./ApprooveOvp.vue?vue&type=template&id=284433c2&"
import script from "./ApprooveOvp.vue?vue&type=script&lang=js&"
export * from "./ApprooveOvp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports